// extracted by mini-css-extract-plugin
export default {"videoOffOuter":"index-module__Qf003","messageOuter":"index-module__gbryt","inSidebar":"index-module__Wwh8n"};